import { useState, useEffect, useMemo, useRef } from "react";
import Button from "@mui/material/Button";
import { Tooltip, useMediaQuery } from "@mui/material";
import {
  Box,
  Typography,
  TextField,
  Autocomplete,
  CircularProgress,
  Grid,
  Card,
} from "@mui/material";
import "chart.js/auto";
import { useNavigate } from "react-router-dom";
import asYouKnowLogo from "../assets/image/AYK.png";
import axios from "axios";

export const TabNull = ({
  searchLabel = "Search by brands, products or types",
  onResults,
  onSearchResultsFound,
  allProductsData,
  initialDataLoading,
}) => {
  const lastSearchPayloadRef = useRef(null);
  const [data, setData] = useState({ matched: [], compared: [] });
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  // const [allProductsData, setAllProductsData] = useState([]);
  // const [initialDataLoading, setInitialDataLoading] = useState(true);
  const [status, setStatus] = useState(0);
  const [showComparison, setshowComparison] = useState(false);
  const [deviceType, setDeviceType] = useState("desktop");
  const [globalData, setglobalData] = useState({});
  const [open, setopen] = useState(false);
  const [showCompare, setShowCompare] = useState(false);
  const [lastTargetYear, setLastTargetYear] = useState(false);
  // const [submitted, setsubmitted] = useState(false);

  useEffect(() => {
    // Example: fetch or set data here
    // After fetching:
    if (!loading && data.matched.length > 0) {
      onSearchResultsFound(true); // tell parent to hide header
    } else {
      onSearchResultsFound(false); // show header again
    }
  }, [loading, data]);

  const isDesktop = useMediaQuery("(min-width:768px)");
  const navigate = useNavigate();

  const handleCompare = () => {
    setshowComparison((prev) => !prev);
    bumpSearchCount(2);
  };

  useEffect(() => {
    // Notify Tabs whenever results change
    onResults(!!data.matched.length);
  }, [data.matched, onResults]);

  useEffect(() => {
    const ua = navigator.userAgent;
    if (/Mobi|Android|iPhone|iPod|iPad/i.test(ua)) {
      setDeviceType("mobile");
    } else {
      setDeviceType("desktop");
    }
  }, []);

  // useEffect(() => {
  //   const fetchAllProductsData = async () => {
  //     setInitialDataLoading(true);

  //     try {
  //       const cached = localStorage.getItem("aysa_products");
  //       const cachedTime = localStorage.getItem("aysa_products_time");

  //       if (cached && cachedTime) {
  //         setAllProductsData(JSON.parse(cached));
  //         setInitialDataLoading(false);
  //       }

  //       const response = await fetch(
  //         "https://api.the-aysa.com/get-profit-margin-data",
  //         {
  //           method: "GET",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }

  //       const result = await response.json();
  //       const apiData = result.data || [];

  //       const formattedData = apiData.map((item, index) => ({
  //         id: index,
  //         label: `${item.Brand || ""} ${item["Product Name"] || ""} ${
  //           item.Type || ""
  //         }`.trim(),
  //         value: `${item.Brand || ""} ${item["Product Name"] || ""} ${
  //           item.Type || ""
  //         }`.trim(),
  //         brand: item.Brand || "",
  //         productName: item["Product Name"] || "",
  //         type: item.Type || "",
  //         category: item.Category || "",
  //         profitMargin:
  //           item["Profit Margin"] || item["Profit Margin "] || "N/A",
  //         productionYear:
  //           item["Production Year"] || item["Production Year "] || "N/A",
  //         image: item["Link to Product Pictures"] || "",
  //         // searchText: [
  //         //   (item.Brand || "")?.toLowerCase(),
  //         //   (item["Product Name"] || "")?.toLowerCase(),
  //         //   (item.Type || "")?.toLowerCase(),
  //         //   (item.Category || "")?.toLowerCase(),
  //         // ].filter((text) => text.trim() !== ""),
  //       }));

  //       if (JSON.stringify(formattedData) !== cached) {
  //         console.log("🔄 New data detected — updating...");
  //         setAllProductsData(formattedData);

  //         localStorage.setItem("aysa_products", JSON.stringify(formattedData));
  //         localStorage.setItem("aysa_products_time", Date.now().toString());
  //       } else {
  //         console.log("✅ Data unchanged — using cache");
  //       }

  //     } catch (err) {
  //       console.error("Failed to fetch products data:", err);

  //       const cached = localStorage.getItem("aysa_products");
  //       if (cached) {
  //         setAllProductsData(JSON.parse(cached));
  //       } else {
  //         setError("Failed to load product data. Please refresh the page.");
  //       }
  //     } finally {
  //       setInitialDataLoading(false);
  //     }
  //   };

  //   fetchAllProductsData();
  // }, []);
  // Modified suggestions to only show after 3 characters
  const suggestions = useMemo(() => {
    if (
      !searchQuery ||
      searchQuery.length < 3 ||
      allProductsData.length === 0
    ) {
      return [];
    }

    const query = searchQuery?.toLowerCase().trim();
    const queryWords = query.split(/\s+/).filter((word) => word.length > 0);

    const filteredSuggestions = allProductsData.filter((item) => {
      const brand = item.brand?.toLowerCase() || "";
      const productName = item.productName?.toLowerCase() || "";
      const productType = item.type?.toLowerCase() || "";
      const category = item.category?.toLowerCase() || "";
      const productionYear = String(item.productionYear ?? "").toLowerCase();
      const searchableFields = [
        brand,
        productName,
        productType,
        category,
        productionYear,
      ];

      return queryWords.every((word) =>
        searchableFields.some((field) => field.includes(word)),
      );
    });

    const sortedSuggestions = filteredSuggestions.sort((a, b) => {
      const aBrand = a.brand.toLowerCase();
      const bBrand = b.brand.toLowerCase();
      const aProduct = a.productName.toLowerCase();
      const bProduct = b.productName.toLowerCase();
      const aType = a.type.toLowerCase();
      const bType = b.type.toLowerCase();
      const aCategory = a.category.toLowerCase();
      const bCategory = b.category.toLowerCase();

      const aYear = Number.parseInt(a.productionYear, 10) || 0;
      const bYear = Number.parseInt(b.productionYear, 10) || 0;
      if (aYear !== bYear) return bYear - aYear;

      const aExactBrand = aBrand === query;
      const bExactBrand = bBrand === query;
      if (aExactBrand !== bExactBrand) return bExactBrand - aExactBrand;

      const aBrandStarts = aBrand.startsWith(query);
      const bBrandStarts = bBrand.startsWith(query);
      if (aBrandStarts !== bBrandStarts) return bBrandStarts - aBrandStarts;

      const aProductStarts = aProduct.startsWith(query);
      const bProductStarts = bProduct.startsWith(query);
      if (aProductStarts !== bProductStarts)
        return bProductStarts - aProductStarts;

      const aCategoryStarts = aCategory.startsWith(query);
      const bCategoryStarts = bCategory.startsWith(query);
      if (aCategoryStarts !== bCategoryStarts)
        return bCategoryStarts - aCategoryStarts;

      if (queryWords.length > 1) {
        const aMatchScore = queryWords.reduce((score, word, index) => {
          if (
            aBrand.startsWith(word) ||
            aProduct.startsWith(word) ||
            aCategory.startsWith(word) ||
            String(a.productionYear ?? "").toLowerCase().startsWith(word)
          ) {
            return score + (queryWords.length - index);
          }
          if (
            aBrand.includes(word) ||
            aProduct.includes(word) ||
            aCategory.includes(word) ||
            String(a.productionYear ?? "").toLowerCase().includes(word)
          ) {
            return score + 1;
          }
          return score;
        }, 0);

        const bMatchScore = queryWords.reduce((score, word, index) => {
          if (
            bBrand.startsWith(word) ||
            bProduct.startsWith(word) ||
            bCategory.startsWith(word) ||
            String(b.productionYear ?? "").toLowerCase().startsWith(word)
          ) {
            return score + (queryWords.length - index);
          }
          if (
            bBrand.includes(word) ||
            bProduct.includes(word) ||
            bCategory.includes(word) ||
            String(b.productionYear ?? "").toLowerCase().includes(word)
          ) {
            return score + 1;
          }
          return score;
        }, 0);

        if (aMatchScore !== bMatchScore) return bMatchScore - aMatchScore;
      }

      const aTypeStarts = aType.startsWith(query);
      const bTypeStarts = bType.startsWith(query);
      if (aTypeStarts !== bTypeStarts) return bTypeStarts - aTypeStarts;

      return aBrand.localeCompare(bBrand);
    });

    return sortedSuggestions.slice(0, 15);
  }, [searchQuery, allProductsData]);

  const bumpSearchCount = (extra = 2) => {
    // Use last ref if available, otherwise fallback to current state
    const basePayload = lastSearchPayloadRef.current ?? {
      query: searchQuery,
      device_type: deviceType,
      target_year: lastTargetYear ?? "null",
    };

    if (!basePayload?.query?.trim()) return;

    fetch(
      `${process.env.REACT_APP_API_URL || "https://api.the-aysa.com"}/global-search`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...basePayload,
          weight: extra,
          action: "compare",
        }),
      },
    ).catch(() => { });
  };

  const handleSearch = async (query, year = "null") => {
    if (!query.trim()) {
      setData({ matched: [], compared: [] });
      setSearchQuery("");
      setStatus(0);
      return;
    }

    // ✅ keep state in sync so Compare always has data
    setSearchQuery(query);
    setLastTargetYear(year);

    // ✅ store last successful search for Compare bump
    const payload = {
      query,
      device_type: deviceType,
      target_year: year,
    };
    lastSearchPayloadRef.current = payload;

    const dedupeRepeatedPhrases = (input) => {
      let tokens = input.trim().split(/\s+/);
      if (tokens.length < 2) return input;

      const normalize = (t) => t.toLowerCase().replace(/^[^\w]+|[^\w]+$/g, "");

      let changed = true;
      while (changed && tokens.length > 1) {
        changed = false;
        const norm = tokens.map(normalize);
        const n = tokens.length;
        const maxBlock = Math.floor(n / 2);

        for (let blockLen = maxBlock; blockLen >= 1; blockLen--) {
          // --- Check repeated at start ---
          let startMatch = true;
          for (let i = 0; i < blockLen; i++) {
            if (norm[i] !== norm[blockLen + i]) {
              startMatch = false;
              break;
            }
          }
          if (startMatch) {
            tokens.splice(0, blockLen);
            changed = true;
            break;
          }

          // --- Check repeated at end ---
          let endMatch = true;
          for (let i = 0; i < blockLen; i++) {
            if (norm[n - blockLen + i] !== norm[n - 2 * blockLen + i]) {
              endMatch = false;
              break;
            }
          }
          if (endMatch) {
            tokens.splice(n - blockLen, blockLen);
            changed = true;
            break;
          }
        }
      }

      return tokens.join(" ");
    };

    query = dedupeRepeatedPhrases(query);
    // console.log("query =>>>", query)
    setSearchQuery(query.replace(/\b(\w+)\s+\1\b/gi, "$1"));
    setLoading(true);
    setError("");
    // setsubmitted(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL || "https://api.the-aysa.com"}/global-search`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query,
            device_type: deviceType,
            target_year: year,
          }),
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setglobalData(result);
      setStatus(result.status);

      const searchData = result.data || [];

      const formatItems = (items) => {
        if (!Array.isArray(items)) {
          console.warn("formatItems received non-array:", items);
          return [];
        }

        return items.map((item, index) => {
          const profitMargin = String(
            item["Profit Margin"] || item["Profit Margin "] || "0%",
          );
          const profitMade =
            item["Profit Made"] || item["Profit Made "] || "$0.0";
          const releasePrice =
            item["Release Price"] || item["Release Price "] || "$0.0";
          const productionYear =
            item["Production Year"] || item["Production Year "] || 0;

          return {
            id: `${item["Brand"]}-${item["Product Name"]}-${index}`,
            brand: (item["Brand"] || "").trim(),
            product_name: (item["Product Name"] || "").trim(),
            product_type: (item["Product Type"] || "").trim(),
            production_year: parseInt(productionYear) || 0,
            profit_margin: profitMargin,
            profit_made: profitMade,
            release_price: releasePrice,
            product_url: item["Link to Product Pictures"] || "",
            category: item["Category"] || "",
            similarity: item["similarity"] || 0,
            cluster: item["cluster"] || 0,
            market_price: parseFloat(
              releasePrice?.replace(/[^0-9.]/g, "") || "0",
            ),
            profit_made_value: parseFloat(
              profitMade?.replace(/[^0-9.]/g, "") || "0",
            ),
          };
        });
      };

      const formattedData = formatItems(searchData);
      setData({
        matched: formattedData,
        compared: [],
      });
      setError("");
    } catch (err) {
      console.error("Search failed:", err);
      setError(`Product Not Matched with: ${query}.`);
      setData({ matched: [], compared: [] });
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch(searchQuery);
    }
  };

  const handleSuggestionSelect = (event, value) => {
    // console.log("test daata-?")
    if (value && typeof value === "object") {
      const selectedQuery = value.value;
      setSearchQuery(selectedQuery);
      handleSearch(selectedQuery, value?.productionYear);
    } else if (typeof value === "string") {
      if (suggestions.length >= 1) {
        handleSearch(suggestions[0].label, suggestions[0].productionYear);
        return;
      } else {
        setSearchQuery(value);
        handleSearch(value);
      }
    }
    setStatus(0);
  };

  // const handleSuggestionSelect = (event, value) => {
  //   // Helper: remove repeated words or phrases like "Flat Flat" or "Earrings Earrings"
  //   const cleanRepeatedWords = (text) => {
  //     if (!text) return "";
  //     // Trim + normalize spacing
  //     text = text.trim().replace(/\s+/g, " ");
  //     // Remove immediate duplicate words (case-insensitive)
  //     text = text.replace(/\b(\w+)\s+\1\b/gi, "$1");
  //     return text;
  //   };

  //   if (value && typeof value === "object") {
  //     let selectedQuery = value.value?.trim() || "";
  //     selectedQuery = cleanRepeatedWords(selectedQuery);
  //     console.log("tettts", selectedQuery)
  //     setSearchQuery(selectedQuery);
  //     handleSearch(selectedQuery, value?.productionYear);
  //   }
  //   else if (typeof value === "string") {
  //     let cleanedValue = cleanRepeatedWords(value);
  //     if (suggestions.length >= 1) {
  //       let firstSuggestion = cleanRepeatedWords(suggestions[0].label);
  //       handleSearch(firstSuggestion, suggestions[0].productionYear);
  //     } else {
  //       console.log("tettts 15", cleanedValue)
  //       setSearchQuery(cleanedValue);
  //       handleSearch(cleanedValue);
  //     }
  //   }

  //   setStatus(0);
  // };

  const firstProduct = data.matched?.[0] || {};
  const profitMarginValue = parseFloat(
    String(firstProduct.profit_margin || "0").replace("%", ""),
  );

  const marketPriceValue = firstProduct.market_price || 0;
  const profitValueMade = firstProduct.profit_made_value || 0;

  const chartData = {
    labels: [`Market Price: $${marketPriceValue}`],
    datasets: [
      {
        label: "Profit Margin",
        data: [profitMarginValue],
        backgroundColor: "#4FC3F7",
        categoryPercentage: 0.6,
        barThickness: 80,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `Profit Margin: ${context.raw}%`;
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Product",
          font: { weight: "bold" },
        },
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 25,
          callback: function (value) {
            return `${value}%`;
          },
        },
        title: {
          display: true,
          text: "Profit Margin (%)",
          font: { weight: "bold" },
        },
        grid: {
          color: "#e0e0e0",
        },
      },
    },
  };

  const LoadingComponent = () => (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={8}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography variant="h6" sx={{ mt: 2, color: "text.secondary" }}>
        Searching products...
      </Typography>
      <Typography variant="body2" sx={{ mt: 1, color: "text.disabled" }}>
        Analyzing profit margins and comparing products
      </Typography>
    </Box>
  );

  const InitialLoadingComponent = () => (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={8}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography variant="h6" sx={{ mt: 2, color: "text.secondary" }}>
        Loading product data
      </Typography>
      <Typography variant="body2" sx={{ mt: 1, color: "text.disabled" }}>
        This may take a moment
      </Typography>
    </Box>
  );

  // Show initial loading screen while fetching all products data
  if (initialDataLoading) {
    return <InitialLoadingComponent />;
  }

  return (
    <>
      <div className="meow">
        {data?.matched.length > 0 ? (
          <>
            {showCompare ? (
              <div
                className="pointer d-flex"
                onClick={() => {
                  setShowCompare(false);
                }}
              >
                <img
                  width="22"
                  height="22"
                  src="https://img.icons8.com/sf-ultralight-filled/25/00c062/chevron-left.png"
                  alt="chevron-left"
                />
                <p className="mb-0 ms-1 back2">Back to Product Details</p>
              </div>
            ) : (
              <>
                <div
                  className="pointer d-flex"
                  onClick={() => {
                    onSearchResultsFound(false);
                    setSearchQuery("");
                    setStatus(0);
                    setData({ matched: [], compared: [] });
                    setshowComparison(false);
                    return;
                  }}
                >
                  <img
                    width="22"
                    height="22"
                    src="https://img.icons8.com/sf-ultralight-filled/25/00c062/chevron-left.png"
                    alt="chevron-left"
                  />
                  <p className="mb-0 ms-1 back2">Back to Home</p>
                </div>
                <Typography
                  variant="h4"
                  textAlign="center"
                  fontWeight="600"
                  fontSize="40px"
                >
                  {" "}
                  Profit Margins
                </Typography>{" "}
              </>
            )}
          </>
        ) : (
          ""
        )}

        {showCompare ? (
          ""
        ) : (
          <Box
            className={
              !loading && data.matched.length > 0
                ? "nomargin texter"
                : "nomargin "
            }
          >
            <label className="product_search">
              Search by brands, products, or type
            </label>
            <Autocomplete
              freeSolo
              className="autoinput mt-2"
              options={suggestions}
              getOptionLabel={(option) => {
                if (typeof option === "string") return option;
                return option.label || "";
              }}
              inputValue={searchQuery}
              onInputChange={(event, newInputValue) => {
                if (
                  event?.nativeEvent?.inputType === "insertText" &&
                  event.nativeEvent.data === " "
                ) {
                  setSearchQuery((prev) => prev + " ");
                  return;
                }

                newInputValue = newInputValue.replace(/\s+/g, " ");
                if (!newInputValue) {
                  setSearchQuery("");
                  setStatus(0);

                  setData({ matched: [], compared: [] });
                  setshowComparison(false);
                  return;
                }
                // if (submitted) {
                //   console.log("here1");
                //   setsubmitted(false);
                // } else {
                //   console.log("here2");
                const cleanRepeatedWords = (text) => {
                  if (!text) return "";
                  // Trim + normalize spacing
                  text = text.trim().replace(/\s+/g, " ");
                  // Remove immediate duplicate words (case-insensitive)
                  text = text.replace(/\b(\w+)\s+\1\b/gi, "$1");
                  return text;
                };

                let cleanedValue = cleanRepeatedWords(newInputValue);

                setSearchQuery(cleanedValue);
                // }
                setStatus(0);
              }}
              onChange={handleSuggestionSelect}
              // onKeyDown={handleKeyPress}
              noOptionsText={
                searchQuery.length < 3
                  ? "Type at least 3 characters to search for brands, products, or types..."
                  : suggestions.length > 0
                    ? "" // Don't show "no options" text when suggestions are available
                    : "No matching products found"
              }
              disabled={loading}
              filterOptions={(options) => options}
              renderOption={(props, option) => (
                <Box component="li" {...props} key={option.id}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    {option.image && (
                      <Box sx={{ mr: 2 }}>
                        <img
                          src={option.image}
                          alt={option.label}
                          style={{
                            width: 40,
                            height: 40,
                            objectFit: "cover",
                            borderRadius: "4px",
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      </Box>
                    )}
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="body2" fontWeight="bold">
                        <span style={{ color: "#1976d2" }}>{option.brand}</span>{" "}
                        {option.productName}
                        <span style={{ color: "#666", fontWeight: "normal" }}>
                          {" "}
                          - {option.type}
                        </span>
                        {option.category && (
                          <span style={{ color: "#999", fontWeight: "normal" }}>
                            {" "}
                            • {option.category}
                          </span>
                        )}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {option.profitMargin} margin • {option.productionYear}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  //label={searchLabel}
                  variant="outlined"
                  className="input-form"
                  placeholder="Start typing here..."
                  fullWidth
                  disabled={loading || initialDataLoading}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading && <CircularProgress size={20} />}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Box>
        )}
      </div>
      {loading && <LoadingComponent />}
      {error && (
        <Box textAlign="center" my={4}>
          <Typography color="error" variant="h6">
            {error}
          </Typography>
        </Box>
      )}
      {!loading && searchQuery && !error && (
        <>
          {/* Case 1: API status 404 */}
          {status === 404 && (
            <Box textAlign="center" my={6}>
              <Typography variant="h6" color="text.secondary">
                Product Not Matched with "<strong>{searchQuery}</strong>"
              </Typography>
            </Box>
          )}

          {/* Case 2: No API hit yet (status === 0), but suggestions exist */}

          {/* {status === 0 && suggestions.length > 0 && !data.matched.length && (
            <Box textAlign="center" my={6}>
              <Typography variant="h6" color="text.secondary">
                Product Not Matched with "<strong>{searchQuery}</strong>"
              </Typography>
            </Box>
          )} */}

          {/* Case 3: No API hit, no suggestions */}
          {/* {status === 0 && suggestions.length === 0 && !data.matched.length && (
            <Box textAlign="center" my={6}>
              <Typography variant="h6" color="text.secondary">
                Product Not Matched with "<strong>{searchQuery}</strong>"
              </Typography>
            </Box>
          )} */}
        </>
      )}
      {
        !loading && data.matched.length > 0 && (
          // (isDesktop ? (
          <>
            {!showCompare ? (
              <div className="serachedProduct">
                <Typography
                  variant="h4"
                  align="center"
                  fontWeight="bold"
                  my={4}
                  sx={{ textTransform: "capitalize" }}
                >
                  {`${firstProduct.brand}`.replace(/\b(\w+)\s+\1\b/gi, "$1")}
                  {
                    <Tooltip
                      title="an estimate"
                      placement="top"
                      sx={{ cursor: "pointer" }}
                    >
                      *
                    </Tooltip>
                  }
                </Typography>
                <Grid
                  container
                  // spacing={2}
                  gap={2}
                  className="Tab-con"
                >
                  {/* Left Column */}
                  <Grid
                    item
                    xs={12}
                    md={6}
                    className="items-show"
                    textAlign="center"
                    border={1}
                    borderColor="#312f2f33"
                    borderRadius={1}
                  >
                    <Box>
                      <Box>
                        {firstProduct.product_url ? (
                          <Box>
                            <div className="d-flex">
                              <img
                                src={firstProduct.product_url}
                                alt={`${firstProduct.brand} ${firstProduct.product_name}`}
                                className="profit-img"
                                // onError={(e) => {
                                //   e.target.style.display = "block";
                                // }}

                                onError={(e) => {
                                  e.currentTarget.src =
                                    "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIGZpbGw9IiNGNUY1RjUiLz48cGF0aCBkPSJNMjAgMjBINDBWNDBIMjBWMjBaIiBmaWxsPSIjRERERERFIi8+PC9zdmc+";
                                  e.currentTarget.style.width = "200px"; // 👈 enforce width even on fallback
                                  e.currentTarget.style.height = "200px";
                                }}
                              />
                              <div className="p-3 text-start ms-auto">
                                <p className="pr_name">
                                  {firstProduct.production_year}{" "}
                                  {firstProduct.product_name}
                                </p>
                                {/* <p className="msrp-cost">
                                  MSRP: {globalData?.data[0]["Release Price"]}
                                </p>
                                <p className="msrp-cost">
                                  Company Cost: {globalData?.data[0]["Profit Made"] || "N/A"}
                                </p> */}
                              </div>
                            </div>

                            <div className="summary-box w-full p-[6px] border-t-[2px] w-[96%] mx-auto  mt-8 text-start lg:block hidden">
                              <label className="pro-heading">Summary</label>
                              <p className="textleft msrp">
                                {firstProduct.brand} makes{" "}
                                {globalData?.data[0]["Profit Made"] ?? "$0.0"}{" "}
                                on a {globalData?.data[0]["Release Price"]}{" "}
                                {firstProduct.product_name}, and its CEO earns{" "}
                                {deviceType === "desktop" ? (
                                  <>
                                    {globalData?.ceo_worker_data.length > 0
                                      ? `${globalData.ceo_worker_data[0][
                                        "Pay Ration"
                                      ]
                                        //.toString()
                                        ?.toLowerCase()
                                        .replace("x", " ")}`
                                      : "0"}{" "}
                                  </>
                                ) : (
                                  <>
                                    {globalData?.ceo_worker_data.length > 0
                                      ? `${globalData.ceo_worker_data[0][
                                        "Pay Ratio"
                                      ]
                                        //.toString()
                                        ?.toLowerCase()
                                        .replace("x", " ")}`
                                      : "0"}{" "}
                                  </>
                                )}
                                times more than the average worker.
                              </p>
                            </div>
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              width: "100%",
                              height: "300px",
                              backgroundColor: "#f5f5f5",
                              borderRadius: "12px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Typography color="text.disabled">
                              No image available
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                      minWidth: "260px",
                    }}
                    className="items-show"
                    padding={2}
                    border={1}
                    borderColor="#312f2f33"
                    borderRadius={1}
                  >
                    <div className="w-full">
                      {/* Label Row */}
                      <div className="flex justify-between mb-1">
                        <span className="text-md  text-gray-700 pro-heading">
                          Profit Margin
                        </span>
                        <span className="text-md pro-text text-gray-700">
                          {globalData?.data[0]["Profit Margin"] || "0%"}
                        </span>
                      </div>

                      {/* Progress Bar */}
                      <div className="w-full bg-[#14FF95] rounded-2 h-2">
                        <div
                          className="bg-[#099656] h-2 rounded-2 transition-all duration-500"
                          style={{
                            width: `${Math.min(
                              100,
                              Number(
                                globalData?.data[0]["Profit Margin"]?.replace(
                                  "%",
                                  "",
                                ),
                              ) || 0,
                            )}%`,
                          }}
                        />
                      </div>
                    </div>

                    <hr className="hr-new" />

                    <div className="w-full mt-4">
                      {/* Label Row */}
                      <div className="flex justify-between mb-1">
                        <span className="text-md font-medium text-gray-700 pro-heading">
                          CEO-Worker Pay Gap
                        </span>
                        {/* <span className="text-md font-medium text-gray-700">
                          {globalData.ceo_worker_data.length > 0
                            ? `${globalData.ceo_worker_data[0]["Pay Ration"]
                              // .toString()
                              ?.toLowerCase()
                              .replace("x", " x")} `
                            : "N/A"}
                        </span> */}

                        <span className="text-md pro-text text-gray-700">
                          {globalData?.ceo_worker_data?.length > 0 ? (
                            deviceType === "desktop" ? (
                              <>
                                {globalData.ceo_worker_data[0]["Pay Ration"]
                                  ?.toString()
                                  .toLowerCase()
                                  .replace("x", " x")}
                              </>
                            ) : (
                              <>
                                {globalData.ceo_worker_data[0]["Pay Ratio"]
                                  ?.toString()
                                  .toLowerCase()
                                  .replace("x", " x")}
                              </>
                            )
                          ) : (
                            "0x"
                          )}
                        </span>
                      </div>

                      {/* Progress Bar */}
                      <div className="w-full bg-[#14FF95] rounded-2 h-2">
                        {globalData?.ceo_worker_data?.length > 0 && (
                          <div
                            className="bg-[#099656] h-2 rounded-2 transition-all duration-500"
                            style={{
                              width: `${deviceType === "desktop"
                                ? Math.min(
                                  parseFloat(
                                    globalData.ceo_worker_data[0]?.[
                                      "Pay Ration"
                                    ]
                                      ?.toLowerCase()
                                      .replace("x", ""),
                                  ) || 0,
                                  100,
                                )
                                : Math.min(
                                  parseFloat(
                                    globalData.ceo_worker_data[0]?.[
                                      "Pay Ratio"
                                    ]
                                      ?.toLowerCase()
                                      .replace("x", ""),
                                  ) || 0,
                                  100,
                                )
                                }%`,
                            }}
                          />
                        )}
                      </div>
                    </div>

                    {globalData?.data[0]?.ayk_workplace_equity && (
                      <>
                        <hr className="hr-new" />
                        <a
                          className="workspace-bg w-full mt-4 block"
                          href={
                            globalData.data[0].ayk_link ||
                            "https://asyouknow.com/"
                          }
                          onClick={() => {
                            axios.post(
                              `${process.env.REACT_APP_API_URL || "https://api.the-aysa.com"}/workplace_equity_track`,
                              {
                                workplace_flag: true,
                                tab_type: "profit",
                                product_obj: globalData.data[0]
                              },
                            );
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none" }}
                        >
                          <div className="flex justify-between mb-1 items-center">
                            <span className="text-md text-blue-600 underline pro-heading flex items-center gap-2">
                              Workplace Equity by As You Know
                            </span>
                            <Tooltip
                              title="This score reflects workforce equity disclosures and documented corporate practices related to racial justice, community engagement, and environmental justice, including violations and community impacts. Based on research by As You Sow, licensed through As You Know"
                              slotProps={{
                                tooltip: {
                                  sx: {
                                    fontSize: "20px",
                                    lineHeight: 1.6,
                                    maxWidth: 500,
                                    padding: "16px 20px",
                                  },
                                },
                              }}
                              sx={{ cursor: "pointer" }}
                            >
                              <span
                                className="text-md pro-text text-gray-700"
                                style={{ textDecoration: "underline dotted" }}
                              >
                                {globalData.data[0].ayk_workplace_equity}
                              </span>
                            </Tooltip>
                          </div>
                          <div className="w-full bg-[#8FB8E8] rounded-2 h-2">
                            <div
                              className="bg-[#0A2F5C] h-2 rounded-2 transition-all duration-500"
                              style={{
                                width: `${Math.min(
                                  100,
                                  parseFloat(
                                    String(
                                      globalData.data[0].ayk_workplace_equity,
                                    ).replace("%", ""),
                                  ) || 0,
                                )}%`,
                              }}
                            />
                          </div>
                        </a>
                      </>
                    )}

                    <hr className="hr-new" />

                    <div className="w-full mt-4 lg:block hidden">
                      <div className="flex justify-between mb-1">
                        <h5 className="text-lg pro-heading text-gray-700">
                          Tax Avoidance
                        </h5>
                      </div>

                      <div className="flex gap-2 justify-between">
                        <div className="mb-1 w-[49%] border rounded-md p-5">
                          <span className="text-md pro-text2 text-gray-700">
                            Tax Paid:
                          </span>
                          <br />
                          <span className="text-md pro-text2 text-gray-700">
                            {globalData?.tax_data?.["Taxes Paid"] ?? "$0.0"}
                          </span>
                        </div>
                        <div className=" mb-1 w-[49%] mr-[7px] rounded-md border p-5">
                          <span className="text-md pro-text2 text-gray-700">
                            Tax Avoided:
                          </span>{" "}
                          <br />
                          <span className="text-md pro-text2 text-gray-700">
                            {globalData?.tax_data?.["Taxes Avoided"] ?? "$0.0"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>

                <Grid>
                  <div className="w-full mt-4 lg:hidden ">
                    <div className="flex justify-between mb-1">
                      <h5 className="text-lg pro-heading text-gray-700">
                        Tax Avoidance
                      </h5>
                    </div>

                    <div className="flex gap-2 justify-between">
                      <div className="mb-1 w-[49%] border rounded-md p-5">
                        <span className="text-md pro-text2 text-gray-700">
                          Tax Paid:
                        </span>
                        <br />
                        <span className="text-md pro-text2 text-gray-700">
                          {globalData?.tax_data?.["Taxes Paid"] ?? "$0.0"}
                        </span>
                      </div>
                      <div className=" mb-1 w-[49%] mr-[7px] rounded-md border p-5">
                        <span className="text-md pro-text2 text-gray-700">
                          Tax Avoided:
                        </span>{" "}
                        <br />
                        <span className="text-md pro-text2 text-gray-700">
                          {globalData?.tax_data?.["Taxes Avoided"] ?? "$0.0"}
                        </span>
                      </div>
                    </div>
                  </div>
                </Grid>
                <div className="w-full lg:hidden mt-4 text-start">
                  <label className="pro-heading">Summary</label>
                  <p className="textleft msrp">
                    {firstProduct.brand} makes{" "}
                    {globalData?.data[0]["Profit Made"] ?? "$0.0"} on a{" "}
                    {globalData?.data[0]["Release Price"]}{" "}
                    {firstProduct.product_name}, and its CEO earns{" "}
                    {deviceType === "desktop" ? (
                      <>
                        {globalData?.ceo_worker_data.length > 0
                          ? `${globalData.ceo_worker_data[0]["Pay Ration"]
                            //.toString()
                            ?.toLowerCase()
                            .replace("x", " ")}`
                          : "0x"}{" "}
                      </>
                    ) : (
                      <>
                        {globalData?.ceo_worker_data.length > 0
                          ? `${globalData.ceo_worker_data[0]["Pay Ratio"]
                            //.toString()
                            ?.toLowerCase()
                            .replace("x", " ")}`
                          : "0x"}{" "}
                      </>
                    )}
                    times more than the average worker.
                  </p>
                </div>

                {globalData.data.length > 1 && (
                  <>
                    <div
                      className="contact-btn lg:w-[403px] sm:w-[75%] xs:w-full mx-auto"
                      onClick={() => {
                        setShowCompare(true);
                        bumpSearchCount(2);
                      }}
                    >
                      Click Here to Compare Similar Products!
                    </div>
                  </>
                )}
                {/* data.matched.length > 1 && (
                <div className="w-full mt-4">
                  <Button variant="contained" onClick={handleCompare}>
                    <MdOutlineCompareArrows className="compareIcon" /> Click
                    Here to Compare Profit Margins
                  </Button>
                </div>
              )*/}
              </div>
            ) : (
              <>
                {globalData.data.length > 1 && (
                  <>
                    <div className="comparisonTable">
                      <Box sx={{ mt: 3 }}>
                        {/* <Typography
                    variant="h4"
                    align="center"
                    sx={{ fontWeight: "bold", mb: 3 }}
                  >
                    Comparing Profit Margins
                  </Typography> */}

                        {/* <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(200px, 1fr))",
                      gap: 3,
                    }}
                  >
                    {globalData.data.map((row, i) => (
                      <Card
                        key={row.id}
                        elevation={3}
                        sx={{
                          p: 2,
                          textAlign: "center",
                          borderRadius: 3,
                        }}
                      >
                      
                        
                        <Box sx={{ mb: 2 }}>
                          {row["Link to Product Pictures"] ? (
                            <img
                              src={row["Link to Product Pictures"]}
                              alt={`${row.brand} ${row.product_name}`}
                              style={{
                                width: "100%",
                                maxHeight: 150,
                                objectFit: "contain",
                                borderRadius: "8px",
                              }}
                              onError={(e) => {
                                e.currentTarget.src =
                                  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIGZpbGw9IiNGNUY1RjUiLz48cGF0aCBkPSJNMjAgMjBINDBWNDBIMjBWMjBaIiBmaWxsPSIjRERERERFIi8+PC9zdmc+";
                              }}
                            />
                          ) : (
                            <Box
                              sx={{
                                width: "100%",
                                height: 150,
                                backgroundColor: "#f0f0f0",
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Typography
                                variant="caption"
                                color="text.disabled"
                              >
                                No Image
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold", mb: 1 }}
                        >
                          {`${row.Brand} ${row["Product Name"]}`.replace(
                            /\b(\w+)\s+\1\b/gi,
                            "$1"
                          )}
                        </Typography>

                        <Box sx={{ width: "100%", mb: 1 }}>
                          <Box
                            sx={{
                              width: "100%",
                              height: 12,
                              backgroundColor: "#e0e0e0",
                              borderRadius: 2,
                              overflow: "hidden",
                            }}
                          >
                            <Box
                              sx={{
                                height: "100%",
                                backgroundColor: "#2196f3",
                                borderRadius: 2,
                                transition: "width 0.5s ease",
                                width: `${(row["Profit Margin"] || "0%")
                                  .toString()
                                  .replace(/\s+/g, "")}`,
                              }}
                            />
                          </Box>
                        </Box>

                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold" }}
                          align="left"
                        >
                          {(row["Profit Margin"] || "0%")
                            .toString()
                            .replace(/\s+/g, "")}
                        </Typography>

                       
                      </Card>
                    ))}
                  </Box> */}

                        {/* <Grid container spacing={3}> */}
                        {/* 🔹 Featured (First) Item — always on top */}
                        {globalData.data.length > 0 && (
                          <Grid item xs={12} className="mb-3">
                            <Card
                              elevation={4}
                              sx={{
                                p: 1,
                                textAlign: "center",
                                borderRadius: 3,
                                backgroundColor: "#f9f9f9",
                                boxShadow: "none",
                              }}
                              className="compare-div"
                            >
                              <Box sx={{ mb: 0 }}>
                                {globalData.data[0][
                                  "Link to Product Pictures"
                                ] ? (
                                  <>
                                    <div className="flex justify-between items-center">
                                      <img
                                        src={
                                          globalData.data[0][
                                          "Link to Product Pictures"
                                          ]
                                        }
                                        alt={`${globalData.data[0].brand} ${globalData.data[0].product_name}`}
                                        style={{
                                          width: "100%",
                                          maxHeight: 150,
                                          objectFit: "contain",
                                          borderRadius: "8px",
                                        }}
                                        className="compare-img"
                                      />

                                      <div className="text-start ms-2">
                                        <Typography
                                          variant="h6"
                                          sx={{
                                            fontWeight: "bold",
                                            mb: 0,
                                            fontSize: "36px",
                                          }}
                                          className="text-size1"
                                        >
                                          {`${globalData.data[0].Brand} `.replace(
                                            /\b(\w+)\s+\1\b/gi,
                                            "$1",
                                          )}
                                        </Typography>

                                        <Typography
                                          variant="p"
                                          sx={{ mb: 0 }}
                                          className="text-size"
                                        >
                                          {`${globalData.data[0]["Production Year"]} ${globalData.data[0]["Product Name"]}`.replace(
                                            /\b(\w+)\s+\1\b/gi,
                                            "$1",
                                          )}
                                        </Typography>
                                        <br />

                                        <Typography
                                          variant="p"
                                          sx={{ mb: 1 }}
                                          className="text-size2"
                                        >
                                          Profit Margin:{" "}
                                          {(
                                            globalData.data[0][
                                            "Profit Margin"
                                            ] || "0%"
                                          )
                                            .toString()
                                            .trim()}
                                        </Typography>

                                        <Box
                                          className="progres-br"
                                          sx={{ width: "100%", mb: 0 }}
                                        >
                                          <Box
                                            sx={{
                                              width: "100%",
                                              height: 30,
                                              backgroundColor: "#fff",
                                              borderRadius: 0,
                                              overflow: "hidden",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                height: "100%",
                                                backgroundColor: "#14FF95",
                                                borderRadius: 0,
                                                transition: "width 0.5s ease",
                                                width: `${(
                                                  globalData.data[0][
                                                  "Profit Margin"
                                                  ] || "0%"
                                                )
                                                  .toString()
                                                  .replace(/\s+/g, "")}`,
                                              }}
                                            />
                                          </Box>
                                          {/* {globalData.data[0].ayk_workplace_equity && (
                                          <Box
                                            component="a"
                                            href={globalData.data[0].ayk_link || "https://asyouknow.com/"}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                              display: "inline-flex",
                                              alignItems: "center",
                                              gap: 0.75,
                                              mt: 1,
                                              px: 1.25,
                                              py: 0.5,
                                              borderRadius: "20px",
                                              backgroundColor: "#0A2F5C",
                                              textDecoration: "none",
                                            }}
                                          >
                                            <img
                                              src={asYouKnowLogo}
                                              alt="As You Know"
                                              style={{ width: 18, height: 18, borderRadius: "50%" }}
                                            />
                                            <Typography sx={{ color: "#fff", fontSize: "12px", fontWeight: 500 }}>
                                              Workplace Equity by As You Know —{" "}
                                              <Tooltip
                                                title="Score reflects gender and racial pay equity, workforce representation, and promotion practices, as measured by As You Know."
                                                placement="top"
                                                sx={{ cursor: "pointer" }}
                                              >
                                                <span style={{ textDecoration: "underline dotted" }}>
                                                  {globalData.data[0].ayk_workplace_equity}
                                                </span>
                                              </Tooltip>
                                            </Typography>
                                          </Box>
                                        )} */}
                                        </Box>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <Box
                                    sx={{
                                      width: "100%",
                                      height: 250,
                                      backgroundColor: "#f0f0f0",
                                      borderRadius: "8px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      color="text.disabled"
                                    >
                                      No Image
                                    </Typography>
                                  </Box>
                                )}
                              </Box>

                              {/* <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
                                  {`${globalData.data[0].Brand} ${globalData.data[0]["Product Name"]}`.replace(
                                    /\b(\w+)\s+\1\b/gi,
                                    "$1"
                                  )}
                                </Typography>

                                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                  {(globalData.data[0]["Profit Margin"] || "0%").toString().trim()}
                                </Typography> */}
                            </Card>
                          </Grid>
                        )}

                        {/* 🔹 Remaining Items — always below */}
                        {globalData.data.length > 1 && (
                          <>
                            <h4 className="text-start text-new compare">
                              Compared to
                            </h4>
                            <Grid spacing={3} className="compare-down">
                              {globalData.data.slice(1).map((row, i) => (
                                <Card
                                  elevation={3}
                                  className="card-compare"
                                  sx={{
                                    p: 2,
                                    textAlign: "center",
                                    borderRadius: 1,
                                    boxShadow: "none",
                                    border: "1px solid #B7B7B7",
                                    width: "100%",
                                  }}
                                >
                                  <Box sx={{ mb: 2 }} className="w-[40%]">
                                    {row["Link to Product Pictures"] ? (
                                      <img
                                        src={row["Link to Product Pictures"]}
                                        alt={`${row.brand} ${row.product_name}`}
                                        style={{
                                          width: "100%",
                                          maxHeight: 250,
                                          objectFit: "contain",
                                          borderRadius: "8px",
                                        }}
                                        className="compare-img"
                                        onError={(e) => {
                                          e.currentTarget.src =
                                            "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIGZpbGw9IiNGNUY1RjUiLz48cGF0aCBkPSJNMjAgMjBINDBWNDBIMjBWMjBaIiBmaWxsPSIjRERERERFIi8+PC9zdmc+";
                                        }}
                                      />
                                    ) : (
                                      <Box
                                        sx={{
                                          width: "100%",
                                          height: 150,
                                          backgroundColor: "#f0f0f0",
                                          borderRadius: "8px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <Typography
                                          variant="caption"
                                          color="text.disabled"
                                        >
                                          No Image
                                        </Typography>
                                      </Box>
                                    )}
                                  </Box>
                                  <div className="lg:w-full md:w-full ms-2">
                                    <Typography
                                      variant="h6"
                                      textAlign="start"
                                      className="text-size1"
                                      sx={{ mb: 0 }}
                                    >
                                      {`${row.Brand} `.replace(
                                        /\b(\w+)\s+\1\b/gi,
                                        "$1",
                                      )}
                                    </Typography>

                                    <div className="text-start">
                                      <Typography
                                        variant="p"
                                        textAlign="start"
                                        sx={{ mb: 1, textAlign: "start" }}
                                        className="text-size"
                                      >
                                        {`${row["Production Year"]} ${row["Product Name"]}`.replace(
                                          /\b(\w+)\s+\1\b/gi,
                                          "$1",
                                        )}
                                      </Typography>
                                    </div>
                                    {/* <br /> */}

                                    <div className="text-start">
                                      <Typography
                                        variant="p"
                                        textAlign="start"
                                        className="text-size2"
                                      >
                                        Profit Margin:{" "}
                                        {(row["Profit Margin"] || "0%")
                                          .toString()
                                          .trim()}
                                      </Typography>
                                    </div>

                                    <Box
                                      className="progres-br"
                                      sx={{ width: "100%", mb: 0 }}
                                    >
                                      <Box
                                        sx={{
                                          width: "100%",
                                          height: 30,
                                          backgroundColor: "#fff",
                                          borderRadius: 0,
                                          overflow: "hidden",
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            height: "100%",
                                            backgroundColor: "#14FF95",
                                            borderRadius: 0,
                                            transition: "width 0.5s ease",
                                            width: `${(
                                              row["Profit Margin"] || "0%"
                                            )
                                              .toString()
                                              .replace(/\s+/g, "")}`,
                                          }}
                                        />
                                      </Box>
                                    </Box>
                                  </div>
                                </Card>
                              ))}
                            </Grid>
                          </>
                        )}
                        {/* </Grid> */}
                      </Box>
                    </div>
                  </>
                )}
              </>
            )}
          </>
        )

        // )
        // : (
        // <>

        //   <div className="serachedProduct">
        //     <Typography
        //       variant="h4"
        //       align="center"
        //       fontWeight="bold"
        //       my={4}
        //       sx={{ textTransform: "capitalize" }}
        //     >
        //       {`${firstProduct.brand} ${firstProduct.product_name} (${firstProduct.production_year})`.replace(
        //         /\b(\w+)\s+\1\b/gi,
        //         "$1"
        //       )}
        //       <Tooltip
        //         title="an estimate"
        //         placement="top"
        //         open={open}
        //         sx={{ cursor: "pointer" }}
        //       >
        //         <span onClick={() => setopen(!open)}>*</span>
        //       </Tooltip>
        //     </Typography>
        //     <Grid
        //       container
        //       spacing={2}
        //       sx={{
        //         display: "flex",
        //         justifyContent: "space-between",
        //         alignItems: "flex-start",
        //       }}
        //     >
        //       <Grid
        //         item
        //         xs={12}
        //         md={6}
        //         sx={{
        //           minWidth: "100%",
        //         }}
        //       >
        //         <div className="w-full">

        //           <div className="flex justify-between mb-1">
        //             <span className="text-md font-medium text-gray-700">
        //               Profit Margin
        //             </span>
        //             <span className="text-md font-medium text-gray-700">
        //               {globalData?.data[0]["Profit Margin"] || "N/A"}
        //             </span>
        //           </div>

        //           <div className="w-full bg-gray-200 rounded-full h-3">
        //             <div
        //               className="bg-blue-500 h-3 rounded-full transition-all duration-500"
        //               style={{
        //                 width: `${globalData?.data[0]["Profit Margin"] || 0
        //                   }%`,
        //               }}
        //             />
        //           </div>
        //         </div>

        //         <div className="w-full mt-4">

        //           <div className="flex justify-between mb-1">
        //             <span className="text-md font-medium text-gray-700">
        //               CEO-Worker Pay Gap
        //             </span>

        //             <span className="text-md font-medium text-gray-700">
        //               {globalData?.ceo_worker_data?.length > 0 ? (
        //                 deviceType === "desktop" ? (
        //                   <>
        //                     {globalData.ceo_worker_data[0]["Pay Ration"]
        //                       ?.toString()
        //                       .toLowerCase()
        //                       .replace("x", " x")}
        //                   </>
        //                 ) : (
        //                   <>
        //                     {globalData.ceo_worker_data[0]["Pay Ratio"]
        //                       ?.toString()
        //                       .toLowerCase()
        //                       .replace("x", " x")}
        //                   </>
        //                 )
        //               ) : (
        //                 "N/A"
        //               )}
        //             </span>
        //           </div>

        //           <div className="w-full bg-gray-200 rounded-full h-3">
        //             {globalData?.ceo_worker_data?.length > 0 && (
        //               <div
        //                 className="bg-blue-500 h-3 rounded-full transition-all duration-500"
        //                 style={{
        //                   width: `${Math.min(
        //                     parseFloat(
        //                       globalData.ceo_worker_data[0]["Pay Ratio"]
        //                         //.toString()
        //                         ?.toLowerCase()
        //                         .replace("x", "")
        //                     ) || 0,
        //                     100 // cap at 100%
        //                   )}%`,
        //                 }}
        //               />
        //             )}
        //           </div>
        //         </div>

        //         <div className="w-full mt-4">
        //           <div className="flex justify-between mb-1">
        //             <h5 className="text-lg font-medium text-gray-700">
        //               Corporate Tax Avoidance
        //             </h5>
        //           </div>
        //           <div className="flex justify-between mb-1">
        //             <span className="text-md font-medium text-gray-700">
        //               Tax Paid:
        //             </span>
        //             <span className="text-md font-medium text-gray-700">
        //               {globalData?.tax_data?.["Taxes Paid"] || "N/A"}
        //             </span>
        //           </div>
        //           <div className="flex justify-between mb-1">
        //             <span className="text-md font-medium text-gray-700">
        //               Tax Avoided:
        //             </span>
        //             <span className="text-md font-medium text-gray-700">
        //               {globalData?.tax_data?.["Taxes Avoided"] || "N/A"}
        //             </span>
        //           </div>
        //         </div>
        //       </Grid>
        //     </Grid>
        //     <div className="w-full mt-4">
        //       <p class="text-left">
        //         {firstProduct.brand} makes{" "}
        //         {globalData?.data[0]["Profit Made"] || "N/A"} on a{" "}
        //         {globalData?.data[0]["Release Price"]}{" "}
        //         {firstProduct.product_name}{" "}
        //         {globalData?.data[0]["Product Type"]}, and its CEO earns{" "}
        //         {globalData?.ceo_worker_data.length > 0
        //           ? `${globalData.ceo_worker_data[0]["Pay Ratio"]
        //             //.toString()
        //             ?.toLowerCase()
        //             .replace("x", " ")}`
        //           : "N/A"}{" "}
        //         more than the average worker.
        //       </p>
        //     </div>
        //     {data.matched.length > 1 && (
        //       <div className="w-full mt-4">
        //         <Button variant="contained" onClick={handleCompare}>
        //           Click Here to Compare Profit Margins
        //         </Button>
        //       </div>
        //     )}
        //   </div>

        //   {globalData.data.length > 1 && showComparison && (
        //     <>
        //       <div className="comparisonTable">
        //         <Box sx={{ mt: 3 }}>
        //           {/* <Typography
        //             variant="h4"
        //             align="center"
        //             sx={{ fontWeight: "bold", mb: 3 }}
        //           >
        //             Comparing Profit Margins
        //           </Typography> */}
        //           <Typography
        //             variant="h4"
        //             align="center"
        //             fontWeight="bold"
        //             my={4}
        //             sx={{ textTransform: "capitalize" }}
        //           >
        //             {`${firstProduct.brand} ${firstProduct.product_name} (${firstProduct.production_year})`.replace(
        //               /\b(\w+)\s+\1\b/gi,
        //               "$1"
        //             )}
        //           </Typography>

        //           <Grid
        //             container
        //             spacing={2}
        //             sx={{
        //               display: "flex",
        //               justifyContent: "space-between",
        //             }}
        //           >
        //             <Box
        //               display="flex"
        //               flexWrap="wrap"
        //               justifyContent="space-between"
        //               sx={{
        //                 width: "100%;",
        //               }}
        //             >
        //               <Card
        //                 elevation={3}
        //                 sx={{
        //                   p: 1,
        //                   textAlign: "center",
        //                   borderRadius: 3,
        //                   width: "35%;",
        //                 }}
        //               >
        //                 <Box
        //                   display="flex"
        //                   flexWrap="wrap"
        //                   justifyContent="center"
        //                 >
        //                   <Box>
        //                     {firstProduct.product_url ? (
        //                       <Box textAlign="center">
        //                         <img
        //                           src={firstProduct.product_url}
        //                           alt={`${firstProduct.brand} ${firstProduct.product_name}`}
        //                           style={{
        //                             width: "100%",
        //                             maxWidth: "120px",
        //                             height: "auto",
        //                             borderRadius: "12px",
        //                             boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        //                           }}
        //                           // onError={(e) => {
        //                           //   e.target.style.display = "block";
        //                           // }}

        //                           onError={(e) => {
        //                             e.currentTarget.src =
        //                               "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIGZpbGw9IiNGNUY1RjUiLz48cGF0aCBkPSJNMjAgMjBINDBWNDBIMjBWMjBaIiBmaWxsPSIjRERERERFIi8+PC9zdmc+";
        //                             e.currentTarget.style.width = "200px"; // 👈 enforce width even on fallback
        //                             e.currentTarget.style.height = "200px";
        //                           }}
        //                         />
        //                         <Typography
        //                           variant="h6"
        //                           align="left"
        //                           fontWeight="bold"
        //                           my={1}
        //                           sx={{
        //                             textTransform: "capitalize",
        //                             fontSize: "14px",
        //                           }}
        //                         >
        //                           {`${firstProduct.brand} ${firstProduct.product_name} (${firstProduct.production_year})`.replace(
        //                             /\b(\w+)\s+\1\b/gi,
        //                             "$1"
        //                           )}
        //                         </Typography>
        //                       </Box>
        //                     ) : (
        //                       <Box
        //                         sx={{
        //                           width: "100%",
        //                           height: "100px",
        //                           backgroundColor: "#f5f5f5",
        //                           borderRadius: "12px",
        //                           display: "flex",
        //                           alignItems: "center",
        //                           justifyContent: "center",
        //                         }}
        //                       >
        //                         <Typography
        //                           variant="h6"
        //                           align="left"
        //                           fontWeight="bold"
        //                           my={1}
        //                           sx={{
        //                             textTransform: "capitalize",
        //                             fontSize: "14px",
        //                           }}
        //                         >
        //                           {`${firstProduct.brand} ${firstProduct.product_name} ${firstProduct.product_type} (${firstProduct.production_year})`.replace(
        //                             /\b(\w+)\s+\1\b/gi,
        //                             "$1"
        //                           )}
        //                         </Typography>
        //                         <Typography color="text.disabled">
        //                           No image available
        //                         </Typography>
        //                       </Box>
        //                     )}
        //                   </Box>
        //                 </Box>
        //               </Card>
        //               <Box
        //                 sx={{
        //                   display: "flex",
        //                   width: "65%",
        //                   justifyContent: "center",
        //                   flexDirection: "column",
        //                   paddingLeft: "5px",
        //                 }}
        //               >
        //                 {globalData.data.map((row, i) => {
        //                   // Clean value
        //                   const rawValue = (row["Profit Margin"] || "0%")
        //                     .replace(/\s/g, "")
        //                     .replace("%", "");
        //                   const numericValue = parseFloat(rawValue) || 0;

        //                   // Cap at 100%
        //                   const cappedValue = Math.min(numericValue, 100);

        //                   // Final width
        //                   const profitMargin = `${cappedValue}%`;

        //                   return (
        //                     <div
        //                       key={i}
        //                       className="mobileCompareGlobalSerach"
        //                       style={{
        //                         display: "flex",
        //                         alignItems: "center",
        //                         paddingBottom: "10px",
        //                       }}
        //                     >
        //                       {/* Brand Label */}
        //                       {/* <Typography
        //                         variant="h6"
        //                         sx={{
        //                           fontWeight: "bold",
        //                           fontSize: "13px",
        //                           width: "80px",
        //                           wordWrap: "break-word",
        //                           marginRight: "5px",
        //                           textAlign: "right",
        //                         }}
        //                       >
        //                         {row.Brand}{" "}
        //                         {row["Product Name"]
        //                           ? row["Product Name"]
        //                               .split(" ")
        //                               .slice(0, 3)
        //                               .join(" ")
        //                           : ""}
        //                       </Typography> */}

        //                       <Typography
        //                         variant="h6"
        //                         sx={{
        //                           fontWeight: "bold",
        //                           fontSize: "13px",
        //                           width: "120px",
        //                           wordWrap: "break-word",
        //                           marginRight: "5px",
        //                           textAlign: "right",
        //                           lineHeight: "18px;",
        //                         }}
        //                       >
        //                         {(() => {
        //                           const brand = row.Brand?.trim() || "";
        //                           const productName =
        //                             row["Product Name"]?.trim() || "";

        //                           // Take only first 3 words of product name
        //                           const productShort = productName
        //                             .split(" ")
        //                             .slice(0, 3)
        //                             .join(" ");

        //                           // Check if product name starts with brand
        //                           const showName = productName
        //                             ?.toLowerCase()
        //                             .startsWith(brand?.toLowerCase())
        //                             ? productShort
        //                             : `${brand} ${productShort}`;

        //                           return showName;
        //                         })()}
        //                       </Typography>

        //                       {/* Bar Container */}
        //                       <Box
        //                         sx={{
        //                           flex: 1,
        //                           ml: 0,
        //                           display: "flex",
        //                           alignItems: "center",
        //                         }}
        //                       >
        //                         <Box
        //                           className="customGraphMobile"
        //                           sx={{
        //                             flex: 1,
        //                             height: 40,
        //                             borderRadius: 0,
        //                             borderLeft: "1px solid #ccc",
        //                             position: "relative",
        //                           }}
        //                         >
        //                           <Box
        //                             sx={{
        //                               height: "100%",
        //                               backgroundColor:
        //                                 i === 0
        //                                   ? "#42a5f5"
        //                                   : i === 1
        //                                     ? "#1e88e5"
        //                                     : "#1565c0",
        //                               borderRadius: 0,
        //                               transition: "width 0.5s ease",
        //                               width: profitMargin, // e.g. "60%"
        //                             }}
        //                           />
        //                           <span className="ml-1">
        //                             {row["Profit Margin"]
        //                               ? `${parseFloat(
        //                                 row["Profit Margin"]
        //                               ).toFixed(2)}%`
        //                               : "N/A"}
        //                           </span>
        //                         </Box>
        //                       </Box>
        //                     </div>
        //                   );
        //                 })}
        //               </Box>
        //             </Box>
        //           </Grid>
        //         </Box>
        //         {globalData.data.map(
        //           (row, i) =>
        //             !loading &&
        //             i === 0 && (
        //               <Typography
        //                 key={i}
        //                 variant="body2"
        //                 color="text.secondary"
        //                 sx={{ mt: 2, color: "#000", fontSize: "16px" }}
        //               >
        //                 {(() => {
        //                   const mainProfit = parseFloat(row["Profit Margin"]);
        //                   const compareOne = parseFloat(
        //                     globalData?.data[1]?.["Profit Margin"] || 0
        //                   );
        //                   const compareTwo = parseFloat(
        //                     globalData?.data[2]?.["Profit Margin"] || 0
        //                   );

        //                   const compareOneWord =
        //                     mainProfit > compareOne ? "higher" : "lower";
        //                   const compareTwoWord =
        //                     mainProfit > compareTwo ? "higher" : "lower";

        //                   return `${row.Brand} makes ${mainProfit.toFixed(
        //                     2
        //                   )}% profit on a ${row["Release Price"]} ${firstProduct.product_name
        //                     } — ${compareOneWord} than ${globalData?.data[1]?.Brand
        //                     } (${compareOne.toFixed(
        //                       2
        //                     )}%) and ${compareTwoWord} than ${globalData?.data[2]?.Brand
        //                     } (${compareTwo.toFixed(2)}%).`;
        //                 })()}
        //               </Typography>
        //             )
        //         )}
        //       </div>
        //     </>
        //   )}
        // </>
        // )
        // )
      }
    </>
  );
};
